import './identifier-input.scss'
import { Component, Watch } from 'vue-property-decorator'
import { faBarcode } from '@fortawesome/free-solid-svg-icons'

import { Item, Movement, LinkableItemLifecycleStates } from '@skinsoft/types'
import { itemSelectors, movementSelectors } from '@skinsoft/selectors'
import { MovementDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { StateInput, ValidationStates } from '@skinsoft/ui'

export const BAR_CODE_READER_CLICK = 'barcode-reader-click'

@Component({
    components: {
        sStateInput: StateInput,
    },
    props: ['item', 'movement'],
    template: require('./identifier-input.html'),
})
export class IdentifierInput extends ReactiveVue {
    public item: Item;
    public movement: Movement;

    public $movementDataStore: MovementDataStore;
    public ValidationStates = ValidationStates;
    public barCodeIcon = faBarcode;

    public $refs: {
        stateInput: StateInput;
    };

    public itemSelectors = itemSelectors;

    get identifier() {
        return itemSelectors.identifier(this.item, this.$i18n.locale);
    }

    get linkableItemState() {
        return movementSelectors.linkableItemState(this.movement, this.item.id);
    }

    public mounted() {
        this.syncLinkableItemState()
    }

    public async validator(value: string) {
        const isValid = value === this.identifier;

        if (!isValid) {
            return false;
        }

        if (this.linkableItemState !== LinkableItemLifecycleStates.SELECTED) {
            // the item has already been transitionned and this is just a first render round trip
            return true;
        }

        try {
            await this.$movementDataStore.transitionLinkableItem(
                movementSelectors.id(this.movement),
                itemSelectors.id(this.item),
                LinkableItemLifecycleStates.IN_TRANSIT,
            );
            return true;
        } catch (error) {
            return false;
        }
    }

    private syncLinkableItemState() {
        if (!this.$refs.stateInput) {
            // for some reason it is undefined for a while after mount
            return;
        }

        switch (this.linkableItemState) {
            case LinkableItemLifecycleStates.FINALIZED:
            case LinkableItemLifecycleStates.IN_TRANSIT:
                this.$refs.stateInput.validate(this.identifier);
                break;
            case LinkableItemLifecycleStates.SELECTED:
                this.$refs.stateInput.reset();
                break;
        }
    }

    @Watch('linkableItemState', { immediate: false, deep: true })
    private onLinkableItemStateChange() {
        this.syncLinkableItemState()
    }

    private openBarCodeReader() {
        if (this.shouldDisplayBarCodeReader) {
            this.emitOnBus(BAR_CODE_READER_CLICK)
        }
    }

    private get shouldDisplayBarCodeReader() {
        return this.linkableItemState === LinkableItemLifecycleStates.SELECTED
    }
}
